import { render, staticRenderFns } from "./CedexDependenciesSidebar.vue?vue&type=template&id=a1c461c0&scoped=true&"
import script from "./CedexDependenciesSidebar.vue?vue&type=script&lang=js&"
export * from "./CedexDependenciesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CedexDependenciesSidebar.vue?vue&type=style&index=0&id=a1c461c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c461c0",
  null
  
)

export default component.exports